import { Box, Typography } from "@mui/material";
import { Scrollbars } from "react-custom-scrollbars";

import { HorizontalStyle } from "./style";

export default function Horizontal() {
    return (
        <HorizontalStyle className="horizontal">
            <Typography className="type-ttile"> Horizontal (Latest Movies )</Typography>
            <Scrollbars>
                <Box className="content-wrapper">
                    <Box className="content-tile">
                        <Typography className="sample-text">
                            <span className="label">Label</span>
                            <span className="time">40:43 mins Left</span>
                        </Typography>
                    </Box>
                    <Box className="content-tile">
                        <Typography className="sample-text">
                            <span className="label">Label</span>
                            <span className="time">40:43 mins Left</span>
                        </Typography>
                    </Box>
                    <Box className="content-tile">
                        <Typography className="sample-text">
                            <span className="label">Label</span>
                            <span className="time">40:43 mins Left</span>
                        </Typography>
                    </Box>
                </Box>
            </Scrollbars>
        </HorizontalStyle>
    );
}
